var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"d-flex align-strech wrapper"},[_c('the-white-navigation',{staticStyle:{"flex":"0 0 auto"}}),_vm._v(" "),_c('main',{staticStyle:{"flex":"1 1 auto"}},[_c('nuxt')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }